module.exports = __webpack_public_path__ + "img/logo-login.a2f05088.jpg";